// @flow

const STATUSES = {
  attention: 'Attention',
  active: 'Active',
  planned: 'Planned',
  finish: 'Finish',
  all: 'All'
};

export default {
  name: 'advertiser',
  path:
    '/advertiser/:advertiserId?filterDeliveryStrategy&filterStatus&filterText&withArchive&filterPeriodStart&filterPeriodEnd&filterStartDate&filterEndDate',
  forwardTo: 'trading-desk.advertiser',
  i18n: ['trading-desk/advertiser'],
  loadComponent: () => import('./index'),
  encodeParams: ({
    // то что пришло из стейта
    advertiserId,
    archived,
    deliveryStrategy,
    status,
    endDate,
    startDate,
    dateFilterType,
    searchText
  }) => {
    const result = {
      advertiserId,
      filterDeliveryStrategy: deliveryStrategy,
      filterStatus: status,
      filterText: searchText,
      withArchive: archived
    };

    if (dateFilterType === 'period') {
      result.filterPeriodStart = startDate;
      result.filterPeriodEnd = endDate;
    } else if (dateFilterType === 'start') {
      result.filterStartDate = startDate;
    } else if (dateFilterType === 'end') {
      result.filterEndDate = endDate;
    }
    return result;
  },
  decodeParams: ({
    // то что пришло из url
    advertiserId,
    filterDeliveryStrategy,
    filterPeriodEnd,
    filterPeriodStart,
    filterStartDate,
    filterEndDate,
    filterStatus,
    filterText,
    withArchive
  }) => {
    const result = {
      advertiserId,
      archived: withArchive === 'true',
      deliveryStrategy: filterDeliveryStrategy,
      status: STATUSES[filterStatus] || filterStatus,
      endDate: filterPeriodEnd || filterEndDate,
      startDate: filterPeriodStart || filterStartDate,
      searchText: filterText
    };

    if (filterPeriodEnd && filterPeriodStart) {
      result.dateFilterType = 'period';
    } else if (filterStartDate) {
      result.dateFilterType = 'start';
    } else if (filterEndDate) {
      result.dateFilterType = 'end';
    } else {
      result.dateFilterType = 'all';
    }
    return result;
  }
};
